<template>
    <header :class="['visual-header', {'is-show': isReady, 'is-mobile-horizontal': isMobileHorizontal}]">
        <div class="visual-header__inner">
            <div class="visual-header__row">
                <a href="//rbi.ru" aria-label="Главная страница" class="visual-header__logo">
                    <iconLogoMobile v-if="isMobile" className="visual-header__logo-image"/>
                    <iconLogoDesktop v-else className="visual-header__logo-image"/>
                </a>
                <a v-if="objectLogo && !visualInnerVersion" :href="objectLogo.href" class="visual-header__object-logo">
                    <img :src="objectLogo.src" :alt="objectLogo.name" class="visual-header__object-logo-image">
                </a>
                <div v-if="objectLogo.name && visualInnerVersion" class="visual-header__object-logo">
                    {{ objectLogo.name }}
                </div>
                <Breadcrumbs modify="visual-header__breadcrumbs"/>
                <div v-if="parametricLink && !$route.query.localhost && !isProfitbase" :class="['visual-header__parametric', {'is-open': isOpen}]">
                    <button class="visual-header__parametric-button" @click="isOpen = !isOpen">
                        <svg width="16" height="15">
                            <use xlink:href="/webicons/sprite.svg#i-search"></use>
                        </svg>
                    </button>
                    <div v-if="!$route.query.localhost && !isProfitbase"
                         class="visual-header__parametric-content">
                        <a :href="parametricLink"
                           :target="visualInnerVersion ? '_blank' : ''"
                           class="link link_theme_dark">
                            <span class="link__inner">Выбрать по параметрам</span>
                            <span class="link__icon">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none"
                                 xmlns="http://www.w3.org/2000/svg" class="link__icon-circle">
                                <g mask="url(#maskLink)">
                                    <path d="M0 0H40V40H0V30H8V10H0V0Z"></path>
                                </g>
                            </svg>
                            <svg width="0" height="0" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"
                                 class="link__icon-circle-mask">
                                <mask id="maskLink" mask-type="alpha" maskUnits="userSpaceOnUse"
                                      x="0" y="0" width="40" height="40">
                                    <circle cx="20" cy="20" r="19.25" stroke="black"/>
                                </mask>
                            </svg>
                            <svg width="8" height="8" class="link__icon-svg link__icon-hyphen">
                                <use xlink:href="/webicons/sprite.svg#i-link-hyphen"></use>
                            </svg>
                            <svg width="5" height="8" class="link__icon-svg link__icon-arrow">
                                <use xlink:href="/webicons/sprite.svg#i-arr-right"></use>
                            </svg>
                        </span>
                        </a>
                    </div>
                </div>
                <a :href="$prevLink" class="visual-header__back">
                    <iconCloseBig/>
                </a>
            </div>
        </div>

        <div v-if="checkVisualStep()" @click="goBack" class="visual-header__back-button">
            <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 1L2 9M10 17L2 9M2 9H16" stroke="#22242A" stroke-width="1.5"/>
            </svg>
        </div>


        <a :href="$prevLink" class="visual-header__back-only">
            <iconCloseBig/>
        </a>
    </header>
</template>

<style lang="scss">
    @import "./Header.scss";
</style>

<script>
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import iconCloseBig from '../Icons/icon-close-big';
import iconLogoDesktop from '../Icons/icon-logo-desktop';
import iconLogoMobile from '../Icons/icon-logo-mobile';
import {mapGetters} from 'vuex';
import {Utils} from 'common/scripts/utils';

export default {
    data() {
        return {
            isMobile: Utils.isMobile(),
            isOpen  : false,
            history : window.history
        };
    },

    props: {
        isMobileHorizontal: Boolean
    },

    components: {
        Breadcrumbs,
        iconLogoDesktop,
        iconLogoMobile,
        iconCloseBig
    },

    computed: {
        ...mapGetters({
            dataStep          : 'GET_DATA_STEP',
            isReady           : 'GET_IS_READY',
            backLink          : 'GET_BACK_LINK',
            objectLogo        : 'GET_OBJECT_LOGO',
            parametricLink    : 'GET_PARAMETRIC_LINK',
            visualInnerVersion: 'GET_VISUAL_VERSION',
            isProfitbase      : 'GET_PROFITBASE'
        })
    },

    created() {
        this.bindEvents();
    },

    methods: {
        bindEvents() {
            const events = ['resize', 'orientationchange'];

            events.forEach((event) => {
                window.addEventListener(event, this.onResize.bind(this));
            });
        },

        onResize() {
            this.isMobile = Utils.isMobile();

            if (!this.isMobile) {
                this.isOpen = false;
            }
        },

        goBack() {
            if (history.length > 1) {
                history.back();
            } else {
                window.location.replace(`https://${document.location.host}`);
            }
        },

        checkVisualStep() {
            return this.dataStep.step !== 'building';
            // let visible = false;
            //
            // if (this.objectLogo.name.indexOf('ARTSTUDIO') > -1) {
            //     // eslint-disable-next-line max-len
            //     visible = this.visualInnerVersion && (this.dataStep.step !== 'building' && this.dataStep.step !== 'floor');
            // } else {
            //     visible = this.visualInnerVersion && this.dataStep.step !== 'building';
            // }
            //
            // return visible;
        }
    }
};
</script>
